import Products from "./pages/products";
import SingleProductOutlet from "./pages/single-product-outlet";
import Overview from "./pages/overview";
import Configuration from "./pages/configuration";
import Transaction from "./pages/transaction";

const ProductRoutes = [
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/products",
    element: <SingleProductOutlet />,
    children: [
      {
        path: "overview/:productId",
        element: <Overview />,
      },
      {
        path: "configuration/:productId",
        element: <Configuration />,
      },
      {
        path: "transactions/:productId",
        element: <Transaction />,
      },
    ],
  },
];

export default ProductRoutes;
